import React, { use, useEffect, useMemo, useState } from "react";
import { routes } from "../../../constants/routes";
import { BreadcrumbComponent } from "../../../common/components";
import EmailTemplateList from "../email-templates/email-template-list";
import { viewOpenProps } from "../email-letter-types";
import AddNewEmailTemplate from "../email-templates/add-new-email-template";
import NewEmailTemplateEditor from "../email-templates/new-email-template-editor/new-email-template-editor";
import PrintablePDFPreview from "../email-templates/printable-pdf-preview";
import { useSetLoading } from "../../../common/hooks/appearance";
import { AlertComponent } from "../../../common/components";
import { useLogin } from "../../../common/hooks/useUser";
import "./letter-templates-list.scss";

interface toggleEditor {
  isOpen: boolean;
  mode: "view" | "edit" | "new";
  template: any;
}

const LetterTemplatesList: React.FC = () => {
  const [showCreateTemplateOpen, setShowCreateTemplateOpen] =
    useState<boolean>(false);
  const [toggleEditor, setToggleEditor] = useState<toggleEditor>({
    isOpen: false,
    mode: "view",
    template: null,
  });
  const [alertMessage, setAlertMessage] = useState<any>({
    open: false,
    message: "",
    type: "info",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isPrintPreviewOpen, setIsPrintPreviewOpen] = useState<boolean>(false);
  const [letterTemplatePdfUrl, setLetterTemplatePdfUrl] = useState<string>("");
  const handleOnCloseEditor = () => {
    setToggleEditor({
      isOpen: false,
      mode: "view",
      template: null,
    });
    setIsLoading(false);
    setShowCreateTemplateOpen(false);
    setCrumbMappingOption(breadcrumbLink); // reset breadcrumbs
  };

  const breadcrumbLink = [
    {
      label: "Letter Templates",
      link: routes.LETTERTEMPLATES,
      handleClick: (event: any) => {
        event.preventDefault();
      },
    },
  ];
  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);
  const [viewOpen, setViewOpen] = useState<viewOpenProps>({
    isOpen: false,
    mode: "view",
    template: null,
  });

  const handleCreateTemplateOpen = () => {
    setToggleEditor({
      isOpen: true,
      mode: "new",
      template: null,
    });
  };

  useEffect(() => {
    if (showCreateTemplateOpen) {
      handleCreateTemplateOpen();
      setCrumbMappingOption([
        {
          label: "Letter Templates",
          link: routes.LETTERTEMPLATES,
          handleClick: (event: any) => {
            event.preventDefault();
            handleOnCloseEditor();
            setCrumbMappingOption(breadcrumbLink); // reset breadcrumbs
          },
        },
        {
          label: "Add Letter Template",
          link: "#",
        },
      ]);
    }
  }, [showCreateTemplateOpen]);

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="leadlist-wrapper letter-templates-wrapper">
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
        </div>
        {isPrintPreviewOpen ? (
          <PrintablePDFPreview pdfUrl={letterTemplatePdfUrl} />
        ) : toggleEditor?.isOpen ? (
          <>
            <NewEmailTemplateEditor
              onClose={handleOnCloseEditor}
              setAlertMessage={setAlertMessage}
              toggleEditor={toggleEditor}
              setViewOpen={setViewOpen}
              setIsLoading={setIsLoading}
              templateType="Letter"
              crumbMappingOption={crumbMappingOption}
              setCrumbMappingOption={setCrumbMappingOption}
              setIsLetterPrintPreviewOpen={setIsPrintPreviewOpen}
              setLetterTemplatePdfUrl={setLetterTemplatePdfUrl}
            />
          </>
        ) : (
          <EmailTemplateList
            viewOpen={viewOpen}
            setViewOpen={setViewOpen}
            crumbMappingOption={crumbMappingOption}
            setCrumbMappingOption={setCrumbMappingOption}
            templateType="Letter"
            setShowCreateTemplateOpen={setShowCreateTemplateOpen}
            setIsLetterPrintPreviewOpen={setIsPrintPreviewOpen}
            setLetterTemplatePdfUrl={setLetterTemplatePdfUrl}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        )}
        <AlertComponent
          message={alertMessage?.message || ""}
          type={alertMessage?.type || "info"}
          open={alertMessage?.open || false}
          onClose={() => { setAlertMessage({ open: false, message: "", type: "info" }) }}
        />
      </div>
    </>
  );
};

export default LetterTemplatesList;
